type AuthScheme = 'JWT' | 'Bearer';

export const headers = (authScheme: AuthScheme = 'JWT') => {
	return {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		Authorization: `${authScheme} ${localStorage.getItem('token')}`,
	};
}
